import { render, staticRenderFns } from "./confirm-mail-2.vue?vue&type=template&id=5aa22745&"
import script from "./confirm-mail-2.vue?vue&type=script&lang=js&"
export * from "./confirm-mail-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports